import type {SVGProps} from "react";

export const LowStockAlertIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="17"
        height="17"
        viewBox="0 0 17 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        {...props}
    >
        <g clipPath="url(#low-stock-alert-clip)">
            <path
                d="M8.27441 14.9958V8.9021"
                stroke="#00C49A"
                strokeWidth="1.35"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M10.4212 1.59631C10.5899 1.50202 10.7798 1.45251 10.973 1.45251C11.1663 1.45251 11.3562 1.50202 11.5249 1.59631L14.3686 3.19423C14.57 3.30811 14.7376 3.47343 14.8542 3.67328C14.9707 3.87313 15.0322 4.10036 15.0322 4.33173C15.0322 4.5631 14.9707 4.79032 14.8542 4.99017C14.7376 5.19002 14.57 5.35534 14.3686 5.46923L6.12174 10.114C5.95261 10.2105 5.76125 10.2612 5.56654 10.2612C5.37182 10.2612 5.18046 10.2105 5.01133 10.114L2.18112 8.5161C1.97972 8.40221 1.81217 8.2369 1.69559 8.03705C1.57901 7.83719 1.51758 7.60997 1.51758 7.3786C1.51758 7.14723 1.57901 6.92001 1.69559 6.72016C1.81217 6.5203 1.97972 6.35499 2.18112 6.2411L10.4212 1.59631Z"
                stroke="#00C49A"
                strokeWidth="1.35"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M13.6908 8.9021V11.5224C13.691 11.778 13.6211 12.0287 13.4885 12.2472C13.356 12.4657 13.166 12.6436 12.9392 12.7615L8.87669 14.8469C8.69056 14.9436 8.48386 14.9941 8.27409 14.9941C8.06432 14.9941 7.85762 14.9436 7.67149 14.8469L3.60899 12.7615C3.38222 12.6436 3.19219 12.4657 3.05965 12.2472C2.92711 12.0287 2.85716 11.778 2.85742 11.5224V8.9021"
                stroke="#00C49A"
                strokeWidth="1.35"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M14.3686 8.51613C14.57 8.40225 14.7376 8.23693 14.8542 8.03708C14.9707 7.83722 15.0322 7.61 15.0322 7.37863C15.0322 7.14726 14.9707 6.92004 14.8542 6.72019C14.7376 6.52034 14.57 6.35502 14.3686 6.24113L6.12852 1.58957C5.96052 1.49336 5.77029 1.44275 5.57669 1.44275C5.3831 1.44275 5.19287 1.49336 5.02487 1.58957L2.18112 3.19426C1.97972 3.30814 1.81217 3.47346 1.69559 3.67331C1.57901 3.87317 1.51758 4.10039 1.51758 4.33176C1.51758 4.56313 1.57901 4.79035 1.69559 4.9902C1.81217 5.19005 1.97972 5.35537 2.18112 5.46926L10.428 10.114C10.5959 10.2105 10.7862 10.2613 10.9798 10.2613C11.1735 10.2613 11.3637 10.2105 11.5316 10.114L14.3686 8.51613Z"
                stroke="#00C49A"
                strokeWidth="1.35"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
        <defs>
            <clipPath id="low-stock-alert-clip">
                <rect width="16.25" height="16.25" fill="white" transform="translate(0.149414 0.0999756)" />
            </clipPath>
        </defs>
    </svg>
);
